import { ReactNode } from 'react'

const MIN_DURATION = 2000
const MAX_DURATION = 8000
const PER_CHAR_MS = 50

export function extractText(node: ReactNode): string {
  if (node == null || typeof node === 'boolean') return ''
  if (typeof node === 'string' || typeof node === 'number') return node.toString()

  if (Array.isArray(node)) return node.map(extractText).join('')

  const element = node as { props?: { children?: ReactNode } }
  if (element.props && 'children' in element.props) {
    return extractText(element.props.children)
  }

  return ''
}

/**
 * The function to calculate how long a toast should stay on‐screen based on text length.
 */
export function calcToastDuration(title: ReactNode, description?: ReactNode): number {
  const text = extractText(title) + extractText(description)
  const length = text.length

  const calculated = MIN_DURATION + length * PER_CHAR_MS
  return Math.min(MAX_DURATION, Math.max(MIN_DURATION, calculated))
}
